import React from "react";
import {PreventNavigationContext} from "./prevent-navigation-context-props.ts";

const usePreventNavigationContext = () => {
    const context = React.useContext(PreventNavigationContext);
    if (context === undefined) {
        throw new Error('usePreventNavigationContext must be used within a ProcessingFlagProvider');
    }
    return context;
};

export default usePreventNavigationContext;